var exports = {
  "M": "traceList__FWAp5s",
  "U": "traceTable__3vSCLp",
};

module.exports = exports;
